import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import { InviteLinks, Userspaces } from '@busy-human/opt-library'
import { createInviteLink } from '@/util/functions';
import VLoader from '@/components/loader.vue';
import {meetingConstants} from "@busy-human/opt-library";
import BackButton from "../buttons/back.vue";
import {setupText} from "./setup-text.js";
import { computed } from '@vue/reactivity';
import { useUserspace } from '@/store/userspace';

type Emits = {
    (e: 'progress'): void
    (e: 'back'):void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'rate-setup',
  emits: ["progress", "back"],
  setup(__props, { expose, emit }: { emit: ({
    (e: 'progress'): void
    (e: 'back'):void
}), expose: any, slots: any, attrs: any }) {
  expose();

const defaults = ref({
    length: {
        min: meetingConstants.MINIMUM_LENGTH,
        max: meetingConstants.MAXIMUM_LENGTH,
        default: meetingConstants.DEFAULT_LENGTH,
    },
    price: {
        min: meetingConstants.MINIMUM_PRICE,
        max: meetingConstants.MAXIMUM_PRICE,
        default: meetingConstants.DEFAULT_PRICE,
    }
})
const text = ref(setupText.payment);



const amount = ref(defaults.value.price.default);
const minutes = ref(defaults.value.length.default);
const loading = ref(false);

let updateDefaultRate = async () =>{
    let user = useUserspace().user;

    loading.value = true;

    let standardInvite = InviteLinks.Defaults()

    standardInvite.name = "Standard Invite";
    standardInvite.price.amount = amount.value;
    standardInvite.minutes = minutes.value;
    standardInvite.collector = user.$id;
    standardInvite.isStandard = true;

    let standardInviteRefId: string | null = null;

    try {
        const tmp = await createInviteLink({data: standardInvite, uid: user.$id});
        if((tmp.data as any).httpErrorCode) {
            throw new Error((tmp.data as any).code);
        } else {
            standardInviteRefId = tmp.data.$id;
        }
    } catch (e) {
        console.error(e);
    }

    await Userspaces.Collection.updateDoc(user.$id, {
        defaultRate: {
            minutes: minutes.value,
            price: {
                'amount': amount.value,
                'currency': '$'
            }
        },
        standardInviteLink: standardInviteRefId
    })
    emit('progress')

}
const costLength = computed(() => {
    return amount.value.toString().length
})
const durationLength = computed(() => {
    return minutes.value.toString().length
})
const clickedBackButton = () =>{
    emit('back')
}


const __returned__ = { defaults, text, emit, amount, minutes, loading, updateDefaultRate, costLength, durationLength, clickedBackButton, ref, InviteLinks, Userspaces, createInviteLink, VLoader, meetingConstants, BackButton, setupText, computed, useUserspace }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})